import { useEffect, useState, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EnvironmentContext } from '../Context/EnvironmentContext';
import { useTranslation } from 'react-i18next';
import { db } from '../firebaseConfig';
import { getFirestore, doc, getDoc, updateDoc } from 'firebase/firestore';

export default function useCouponModal() {
  const env = useContext(EnvironmentContext);
  const [showCouponModal, setShowCouponModal] = useState(false);
  const [autoCoupon, setAutoCoupon] = useState('');
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();

  useEffect(() => {
    // Only show the modal if the user is logged in, has just created an account, and has verified their email
    if (env.user && env.user.uid && env.user.emailVerified) {
      // Check if the user is new (e.g., just created and verified)
      const isNewUser = sessionStorage.getItem('showCouponModalFor_' + env.user.uid);
      if (isNewUser === '1') {
        setShowCouponModal(true);
      } else {
        setShowCouponModal(false);
      }
    } else {
      setShowCouponModal(false);
    }
  }, [env.user]);

  // This function should be called after successful signup and email verification
  const markShowCouponModalForUser = (userId) => {
    sessionStorage.setItem('showCouponModalFor_' + userId, '1');
  };

  const handleRedeemCoupon = async (code) => {
    if (!env.user || !env.user.uid) {
      return { success: false, message: t('InvalidCouponCode') };
    }
  
    // Liste des coupons valides à adapter selon votre contexte
    const validCoupons = ["FABLIA", "FABLIA4000", "FABLIA4EVER", "fablia", "fablia4000", "fablia4ever", "Fablia", "Fablia4000", "Fablia4ever", "Fablia4Ever"];
    if (!validCoupons.includes(code)) {
      return { success: false, message: t('InvalidCouponCode') };
    }
  
    try {
      const userRef = doc(db, 'users', env.user.uid);
      const userSnap = await getDoc(userRef);
  
      if (!userSnap.exists()) {
        return { success: false, message: t('UserNotFound') };
      }
      const userData = userSnap.data();
      if (!userData) {
        return { success: false, message: t('UserDataMissing') };
      }
      if (userData.couponRedeemed) {
        return { success: false, message: t('CouponAlreadyRedeemed') };
      }
  
      // Crédit à accorder (à adapter selon votre logique)
      const CREDIT_AMOUNT = 4000;
      const newTokenCount = (userData.tokenCount || 0) + CREDIT_AMOUNT;
  
      await updateDoc(userRef, {
        tokenCount: newTokenCount,
        couponRedeemed: true,
        couponCode: code,
        couponRedeemedAt: new Date().toISOString(),
      });
      sessionStorage.removeItem('showCouponModalFor_' + env.user.uid);
  
      localStorage.setItem('couponRedeemed_' + env.user.uid, '1');
      return { success: true };
    } catch (e) {
      return { success: false, message: t('InvalidCouponCode') };
    }
  };

  return {
    showCouponModal,
    setShowCouponModal,
    autoCoupon,
    handleRedeemCoupon,
    markShowCouponModalForUser,
  };
}
